<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 34 34" style="enable-background:new 0 0 34 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#989693;}
	.st1{opacity:0.85;fill:#989693;enable-background:new    ;}
	.st2{opacity:0.72;fill:#989693;enable-background:new    ;}
	.st3{opacity:0.58;fill:#989693;enable-background:new    ;}
	.st4{opacity:0.46;fill:#989693;enable-background:new    ;}
	.st5{opacity:0.32;fill:#989693;enable-background:new    ;}
	.st6{opacity:0.19;fill:#989693;enable-background:new    ;}
	.st7{opacity:0.12;fill:#989693;enable-background:new    ;}
</style>
    <circle id="Oval" class="st0" cx="17" cy="10" r="2"/>
    <circle id="Oval-Copy-8" class="st1" cx="12" cy="12" r="2"/>
    <circle id="Oval-Copy-9" class="st2" cx="10" cy="17" r="2"/>
    <circle id="Oval-Copy-10" class="st3" cx="12" cy="22" r="2"/>
    <circle id="Oval-Copy-11" class="st4" cx="17" cy="24" r="2"/>
    <circle id="Oval-Copy-12" class="st5" cx="22" cy="22" r="2"/>
    <circle id="Oval-Copy-13" class="st6" cx="24" cy="17" r="2"/>
    <circle id="Oval-Copy-14" class="st7" cx="22" cy="12" r="2"/>
</svg>
